import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { ReadMoreButton, TextLines, ContentReadMoreButton } from './mixins';

var ReadMore = function ReadMore(_ref) {
  var _ref$readMore = _ref.readMore,
      readMore = _ref$readMore === void 0 ? 'Leer más' : _ref$readMore,
      _ref$readLess = _ref.readLess,
      readLess = _ref$readLess === void 0 ? 'Leer menos' : _ref$readLess,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'left' : _ref$position,
      numberOfLines = _ref.numberOfLines,
      id = _ref.id,
      children = _ref.children;
  var text = children;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      limitText = _useState2[0],
      setLimitText = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showLink = _useState4[0],
      setShowLink = _useState4[1];

  var toggleReadMore = function toggleReadMore() {
    setLimitText(!limitText);
  };

  var showRead = function showRead(element) {
    var heightLimit = 5;
    return element && element.scrollHeight - element.clientHeight >= heightLimit;
  };

  useEffect(function () {
    var element = document.getElementById("".concat(id));
    var isActive = showRead(element);
    setShowLink(isActive);
  }, [children, id]);
  return React.createElement(React.Fragment, null, React.createElement(TextLines, {
    id: id,
    limitText: limitText,
    numberOfLines: numberOfLines
  }, text), React.createElement(ContentReadMoreButton, {
    position: position
  }, text && showLink && React.createElement(ReadMoreButton, {
    buttonoptions: {
      variant: "".concat(variant),
      size: 'small',
      type: 'link'
    },
    onClick: toggleReadMore
  }, limitText ? readMore : readLess)));
};

export default ReadMore;